/* Chapter video player: sections/sunday-video-chapters.liquid.
   One <video> plays a film that may be stored in several parts (Shopify caps
   each video at 10 minutes). Every control works on the film's one timeline:
   global time = part start + the element's currentTime. Changing part swaps the
   element's src, with the last frame held on a canvas so nothing flashes. */
(function () {
  if (window.SundayVideoChapters) return;
  window.SundayVideoChapters = true;

  var OVERLAY_MIN = 640;  // player width (px) from which chapters float over the film
  var HIDE_AFTER = 2600;  // ms of stillness before the bar fades during playback
  var SKIP = 5;           // seconds per arrow key
  var RESTART_GRACE = 3;  // "previous" restarts the chapter if this far in
  var CC_KEY = 'sunday-video-captions';

  // "9:59", "1:02:03" or "9:21.8" -> seconds
  function parseTime(value) {
    var bits = String(value || '').trim().split(':');
    var total = 0;
    for (var i = 0; i < bits.length; i++) total = total * 60 + (parseFloat(bits[i]) || 0);
    return total;
  }

  function fmt(seconds) {
    seconds = Math.max(0, Math.floor(seconds || 0));
    var h = Math.floor(seconds / 3600);
    var m = Math.floor((seconds % 3600) / 60);
    var s = seconds % 60;
    return (h ? h + ':' + (m < 10 ? '0' : '') : '') + m + ':' + (s < 10 ? '0' : '') + s;
  }

  function parseVtt(text) {
    var cues = [];
    text.replace(/\r/g, '').split(/\n{2,}/).forEach(function (block) {
      var lines = block.split('\n');
      for (var i = 0; i < lines.length; i++) {
        if (lines[i].indexOf('-->') === -1) continue;
        var times = lines[i].split('-->');
        cues.push({
          start: parseTime(times[0]),
          end: parseTime(times[1].trim().split(/\s/)[0]),
          text: lines.slice(i + 1).join('\n').replace(/<[^>]*>/g, '')
        });
        return;
      }
    });
    return cues;
  }

  function readPref(key) {
    try { return window.localStorage.getItem(key); } catch (e) { return null; }
  }

  function writePref(key, value) {
    try { window.localStorage.setItem(key, value); } catch (e) { /* private mode */ }
  }

  function focusVisible(el) {
    try { return !!el && el.matches(':focus-visible'); } catch (e) { return false; }
  }

  function fullscreenElement() {
    return document.fullscreenElement || document.webkitFullscreenElement || null;
  }

  function Player(root) {
    var self = this;
    var parts = [];
    try { parts = JSON.parse(root.querySelector('[data-svc-parts]').textContent); } catch (e) { /* bad JSON */ }
    this.parts = parts
      .map(function (p) { return { start: parseTime(p.start), src: String(p.src || '') }; })
      .filter(function (p) { return p.src; })
      .sort(function (a, b) { return a.start - b.start; });
    if (!this.parts.length) return;

    this.root = root;
    this.stage = root.querySelector('.svc__stage');
    this.video = root.querySelector('.svc__video');
    this.still = root.querySelector('.svc__still');
    this.panel = root.querySelector('.svc__panel');
    this.list = root.querySelector('.svc__groups');
    this.bar = root.querySelector('.svc__bar');
    this.scrub = root.querySelector('.svc__scrub');
    this.range = root.querySelector('.svc__range');
    this.handle = root.querySelector('.svc__handle');
    this.tip = root.querySelector('.svc__tip');
    this.tipTitle = root.querySelector('.svc__tip-title');
    this.tipTime = root.querySelector('.svc__tip-time');
    this.timeNow = root.querySelector('.svc__time-now');
    this.timeTotal = root.querySelector('.svc__time-total');
    this.caption = root.querySelector('.svc__captions span');
    this.startTitle = root.querySelector('.svc__start-title');
    this.startMeta = root.querySelector('.svc__start-meta');
    this.startMetaDefault = this.startMeta ? this.startMeta.textContent : '';
    this.nowEls = root.querySelectorAll('[data-svc-now]');
    this.countEls = root.querySelectorAll('[data-svc-count]');
    this.playBtns = root.querySelectorAll('[data-action="play"]');
    this.prevBtns = root.querySelectorAll('[data-action="prev"]');
    this.nextBtns = root.querySelectorAll('[data-action="next"]');
    this.panelToggles = root.querySelectorAll('[data-action="panel"]');
    this.barToggle = root.querySelector('.svc__row [data-action="panel"]');

    this.chapters = [].map.call(root.querySelectorAll('.svc__chapter'), function (btn) {
      var title = btn.querySelector('.svc__chapter-title');
      return { btn: btn, start: parseTime(btn.getAttribute('data-t')), title: title ? title.textContent.trim() : '' };
    });

    var lastStart = Math.max(this.parts[this.parts.length - 1].start, this.chapters.length ? this.chapters[this.chapters.length - 1].start : 0);
    this.duration = parseTime(root.getAttribute('data-duration')) || lastStart + 1;

    this.part = 0;
    this.idle = true;
    this.wantPlay = false;
    this.ended = false;
    this.pendingT = null;   // where we are heading while a seek or part change settles
    this.pendingLocal = null;
    this.chapter = -1;
    this.cues = null;
    this.captionText = '';
    this.layoutMode = '';

    this.video.removeAttribute('controls');
    this.video.preload = 'none';
    root.classList.add('is-ready', 'is-idle');
    root.setAttribute('data-controls', 'on');

    this.buildSegments();
    this.bind();
    this.layout();
    this.setCaptions(readPref(CC_KEY) === '1', true);
    this.readHash(false);
    this.update();

    if ('ResizeObserver' in window) {
      new ResizeObserver(function () { self.layout(); }).observe(root);
    } else {
      window.addEventListener('resize', function () { self.layout(); });
    }
  }

  Player.prototype = {
    /* ---------- timeline ---------- */

    currentTime: function () {
      if (this.pendingT !== null) return this.pendingT;
      return this.parts[this.part].start + (this.video.currentTime || 0);
    },

    partAt: function (t) {
      for (var i = this.parts.length - 1; i > 0; i--) {
        if (t >= this.parts[i].start - 0.01) return i;
      }
      return 0;
    },

    chapterAt: function (t) {
      for (var i = this.chapters.length - 1; i >= 0; i--) {
        if (t >= this.chapters[i].start - 0.25) return i;
      }
      return this.chapters.length ? 0 : -1;
    },

    seek: function (t, play) {
      t = Math.max(0, Math.min(t, this.duration - 0.25));
      this.ended = false;
      this.pendingT = t;
      this.pendingSince = Date.now();

      // Before the first play, only move the cue: nothing downloads until Play
      if (this.idle && !play) {
        this.cueT = t;
        this.updateStart();
        this.update();
        return;
      }

      var idx = this.partAt(t);
      var local = t - this.parts[idx].start;
      if (idx !== this.part || this.video.readyState === 0) {
        this.loadPart(idx, local);
      } else {
        this.video.currentTime = local;
      }
      if (play) this.play();
      this.update();
    },

    loadPart: function (idx, local) {
      var v = this.video;
      this.holdFrame();
      this.part = idx;
      this.pendingLocal = local;
      v.preload = 'auto';
      // The media fragment starts the new part at the right moment; loadedmetadata double-checks
      v.src = this.parts[idx].src.split('#')[0] + (local > 0.05 ? '#t=' + local.toFixed(2) : '');
    },

    holdFrame: function () {
      var v = this.video;
      var c = this.still;
      if (!c || v.readyState < 2 || !v.videoWidth) return;
      c.width = Math.min(v.videoWidth, 1280);
      c.height = Math.round(c.width * v.videoHeight / v.videoWidth);
      try {
        c.getContext('2d').drawImage(v, 0, 0, c.width, c.height);
        c.classList.add('is-on');
      } catch (e) { /* no frame to hold */ }
    },

    settle: function () {
      if (this.still && this.video.readyState >= 2) this.still.classList.remove('is-on');
      if (this.pendingT === null) return;
      var actual = this.parts[this.part].start + (this.video.currentTime || 0);
      if (Math.abs(actual - this.pendingT) < 1.5 || Date.now() - this.pendingSince > 5000) this.pendingT = null;
    },

    /* ---------- playback ---------- */

    play: function () {
      var self = this;
      this.begin();
      this.wantPlay = true;
      this.syncPlaying();
      if (this.video.readyState < 3) this.root.classList.add('is-waiting');
      var promise = this.video.play();
      if (promise && promise.catch) {
        promise.catch(function (err) {
          // AbortError just means a part change interrupted this play() call
          if (err && err.name === 'NotAllowedError') {
            self.wantPlay = false;
            self.syncPlaying();
            self.root.classList.remove('is-waiting');
          }
        });
      }
    },

    pause: function () {
      this.wantPlay = false;
      this.video.pause();
      this.syncPlaying();
      this.wake();
    },

    togglePlay: function () {
      if (this.idle) return this.start();
      if (this.ended) return this.seek(0, true);
      if (this.wantPlay) this.pause(); else this.play();
    },

    start: function () {
      var t = this.cueT || 0;
      this.begin();
      this.seek(t, true);
    },

    // Leave the poster state: bar on, panel tucked away
    begin: function () {
      if (!this.idle) return;
      this.idle = false;
      this.root.classList.remove('is-idle');
      if (this.layoutMode === 'overlay') this.setPanel(false);
      this.wake();
    },

    syncPlaying: function () {
      this.root.classList.toggle('is-playing', this.wantPlay);
      for (var i = 0; i < this.playBtns.length; i++) this.playBtns[i].setAttribute('aria-label', this.wantPlay ? 'Pause' : 'Play');
      if (this.wantPlay) this.scheduleHide(); else this.wake();
    },

    /* ---------- chapters ---------- */

    jumpTo: function (i, play) {
      var c = this.chapters[i];
      if (!c) return;
      this.seek(c.start, play);
    },

    prevChapter: function () {
      var t = this.currentTime();
      var i = this.chapterAt(t);
      if (i < 0) return;
      var target = (t - this.chapters[i].start > RESTART_GRACE || i === 0) ? i : i - 1;
      this.jumpTo(target, this.wantPlay);
    },

    nextChapter: function () {
      var i = this.chapterAt(this.currentTime());
      if (i < this.chapters.length - 1) this.jumpTo(i + 1, this.wantPlay);
    },

    chooseChapter: function (i, fromKeyboard) {
      this.jumpTo(i, true);
      if (this.layoutMode === 'overlay') {
        this.setPanel(false);
        // The chosen row is about to vanish with the panel: keep keyboard focus on the bar
        if (fromKeyboard && this.barToggle) this.barToggle.focus();
      } else {
        // Stacked: the list sits under the film, so bring the film back into view
        var r = this.stage.getBoundingClientRect();
        if (r.top < 0 || r.bottom > window.innerHeight) this.stage.scrollIntoView({ block: 'center', behavior: 'smooth' });
      }
    },

    setChapter: function (i) {
      var old = this.chapters[this.chapter];
      if (old) old.btn.removeAttribute('aria-current');
      this.chapter = i;
      var c = this.chapters[i];
      if (c) c.btn.setAttribute('aria-current', 'true');
      if (this.panelOpen && this.idle) this.revealActive();
      for (var k = 0; k < this.nowEls.length; k++) this.nowEls[k].textContent = c ? c.title : '';
      for (var n = 0; n < this.countEls.length; n++) {
        this.countEls[n].textContent = c ? 'Chapter ' + (i + 1) + ' of ' + this.chapters.length : '';
      }
      if (this.idle) this.updateStart();
    },

    updateStart: function () {
      if (!this.startTitle) return;
      var t = this.cueT || 0;
      var c = this.chapters[this.chapterAt(t)];
      this.startTitle.textContent = t > 0 ? 'Play from ' + fmt(t) : 'Play';
      this.startMeta.textContent = t > 0 && c ? c.title : this.startMetaDefault;
    },

    setPanel: function (open) {
      this.panelOpen = open;
      this.root.setAttribute('data-panel', open ? 'open' : 'closed');
      for (var i = 0; i < this.panelToggles.length; i++) this.panelToggles[i].setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) {
        this.revealActive();
        this.wake();
      } else {
        this.scheduleHide();
      }
    },

    // Centre the current chapter inside the panel's own scroller, never the page
    revealActive: function () {
      var c = this.chapters[this.chapter];
      if (!c || this.layoutMode !== 'overlay' || !this.list) return;
      var lr = this.list.getBoundingClientRect();
      var br = c.btn.getBoundingClientRect();
      this.list.scrollTop += (br.top - lr.top) - (lr.height - br.height) / 2;
    },

    /* ---------- drawing ---------- */

    buildSegments: function () {
      var host = this.root.querySelector('.svc__segs');
      var marks = this.chapters.length ? this.chapters : [{ start: 0 }];
      host.textContent = '';
      this.segs = marks.map(function (m) {
        var seg = document.createElement('span');
        var fill = document.createElement('span');
        seg.className = 'svc__seg';
        fill.className = 'svc__seg-fill';
        seg.appendChild(fill);
        host.appendChild(seg);
        return { el: seg, fill: fill, start: m.start, ratio: -1 };
      });
      this.layoutSegments();
    },

    layoutSegments: function () {
      var d = this.duration;
      var segs = this.segs;
      segs.forEach(function (s, i) {
        s.end = i + 1 < segs.length ? segs[i + 1].start : d;
        s.el.style.left = (s.start / d * 100) + '%';
        s.el.style.width = 'calc(' + ((s.end - s.start) / d * 100) + '% - ' + (i + 1 < segs.length ? 2 : 0) + 'px)';
        s.ratio = -1;
      });
      this.range.max = String(d);
      if (this.timeTotal) this.timeTotal.textContent = ' / ' + fmt(d);
    },

    paint: function (t) {
      this.segs.forEach(function (s) {
        var r = t <= s.start ? 0 : t >= s.end ? 1 : (t - s.start) / (s.end - s.start);
        if (r !== s.ratio) {
          s.ratio = r;
          s.fill.style.transform = 'scaleX(' + r + ')';
        }
      });
      this.handle.style.left = (t / this.duration * 100) + '%';
      this.timeNow.textContent = fmt(t);
    },

    update: function () {
      var t = this.currentTime();
      if (!this.dragging) {
        this.range.value = String(t);
        this.paint(t);
      }
      var i = this.chapterAt(t);
      if (i !== this.chapter) this.setChapter(i);
      var c = this.chapters[i];
      this.range.setAttribute('aria-valuetext', fmt(t) + ' of ' + fmt(this.duration) + (c ? ', ' + c.title : ''));

      var atFirst = i <= 0 && t < RESTART_GRACE;
      var atLast = i >= this.chapters.length - 1;
      for (var p = 0; p < this.prevBtns.length; p++) this.prevBtns[p].disabled = atFirst;
      for (var n = 0; n < this.nextBtns.length; n++) this.nextBtns[n].disabled = atLast;

      this.drawCaption(t);
    },

    showTip: function (t, x) {
      var w = this.scrub.clientWidth;
      var c = this.chapters[this.chapterAt(t)];
      this.tipTitle.textContent = c ? c.title : '';
      this.tipTime.textContent = fmt(t);
      this.tip.classList.add('is-on');
      var half = this.tip.offsetWidth / 2;
      this.tip.style.left = Math.max(half, Math.min(w - half, x)) + 'px';
      var seg = c ? this.segs[this.chapters.indexOf(c)] : null;
      if (this.hoverSeg && this.hoverSeg !== seg) this.hoverSeg.el.classList.remove('is-hover');
      if (seg) seg.el.classList.add('is-hover');
      this.hoverSeg = seg;
    },

    hideTip: function () {
      this.tip.classList.remove('is-on');
      if (this.hoverSeg) this.hoverSeg.el.classList.remove('is-hover');
      this.hoverSeg = null;
    },

    /* ---------- captions ---------- */

    setCaptions: function (on, quiet) {
      var btn = this.root.querySelector('[data-action="captions"]');
      if (!btn) return;
      this.cc = on;
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      if (!quiet) writePref(CC_KEY, on ? '1' : '0');
      if (on && !this.cues && !this.cuesLoading) this.loadCues();
      this.drawCaption(this.currentTime());
    },

    loadCues: function () {
      var self = this;
      var url = this.root.getAttribute('data-captions');
      if (!url || !window.fetch) return;
      this.cuesLoading = true;
      fetch(url)
        .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
        .then(function (text) {
          self.cues = parseVtt(text);
          self.drawCaption(self.currentTime());
        })
        .catch(function () { self.cuesLoading = false; });
    },

    drawCaption: function (t) {
      var text = '';
      if (this.cc && this.cues && !this.idle) {
        for (var i = 0; i < this.cues.length; i++) {
          if (t >= this.cues[i].start && t < this.cues[i].end) { text = this.cues[i].text; break; }
        }
      }
      if (text !== this.captionText) {
        this.captionText = text;
        this.caption.textContent = text;
      }
    },

    /* ---------- controls visibility ---------- */

    wake: function () {
      clearTimeout(this.hideTimer);
      this.root.setAttribute('data-controls', 'on');
      this.scheduleHide();
    },

    scheduleHide: function () {
      var self = this;
      clearTimeout(this.hideTimer);
      if (!this.wantPlay || this.idle) return;
      this.hideTimer = setTimeout(function () { self.hideControls(); }, HIDE_AFTER);
    },

    hideControls: function () {
      var focusInBar = this.bar.contains(document.activeElement) && focusVisible(document.activeElement);
      if (!this.wantPlay || this.idle || this.dragging || this.overBar || focusInBar ||
          (this.panelOpen && this.layoutMode === 'overlay')) return;
      this.root.setAttribute('data-controls', 'off');
    },

    toggleControls: function () {
      if (this.root.getAttribute('data-controls') === 'off') this.wake();
      else if (this.wantPlay) {
        clearTimeout(this.hideTimer);
        this.hideControls();
      }
    },

    /* ---------- layout and full screen ---------- */

    layout: function () {
      var mode = (this.isFullscreen() || this.root.clientWidth >= OVERLAY_MIN) ? 'overlay' : 'stacked';
      if (mode === this.layoutMode) return;
      this.layoutMode = mode;
      this.root.setAttribute('data-layout', mode);
      if (this.panel) {
        if (mode === 'overlay') this.stage.appendChild(this.panel);
        else this.root.appendChild(this.panel);
      }
      // Wide and idle: the chapter list greets the visitor beside the poster
      this.setPanel(!!this.panel && mode === 'overlay' && this.idle);
    },

    isFullscreen: function () {
      return this.root.classList.contains('is-fullscreen');
    },

    toggleFullscreen: function () {
      var self = this;
      var root = this.root;
      if (fullscreenElement()) {
        (document.exitFullscreen || document.webkitExitFullscreen).call(document);
        return;
      }
      if (root.classList.contains('is-pseudo-fs')) return this.setPseudoFullscreen(false);
      var request = root.requestFullscreen || root.webkitRequestFullscreen;
      if (!request) return this.setPseudoFullscreen(true);
      try {
        var promise = request.call(root);
        if (promise && promise.catch) promise.catch(function () { self.setPseudoFullscreen(true); });
      } catch (e) {
        this.setPseudoFullscreen(true);
      }
    },

    // iPhone has no element full screen: pin the player over the page instead, so the chapters come too
    setPseudoFullscreen: function (on) {
      this.root.classList.toggle('is-pseudo-fs', on);
      document.documentElement.classList.toggle('svc-lock', on);
      this.syncFullscreen();
    },

    syncFullscreen: function () {
      var on = fullscreenElement() === this.root || this.root.classList.contains('is-pseudo-fs');
      this.root.classList.toggle('is-fullscreen', on);
      var btn = this.root.querySelector('[data-action="fullscreen"]');
      if (btn) btn.setAttribute('aria-label', on ? 'Exit full screen' : 'Full screen');
      this.layout();
      this.wake();
    },

    /* ---------- deep links: #t=9:59 ---------- */

    readHash: function (fromNavigation) {
      var match = /^#t=([\d:.]+)$/.exec(window.location.hash);
      if (!match) return;
      var t = parseTime(match[1]);
      if (!(t >= 0)) return;
      this.seek(t, fromNavigation && !this.idle ? this.wantPlay : false);
      var stage = this.stage;
      requestAnimationFrame(function () { stage.scrollIntoView({ block: 'center' }); });
    },

    /* ---------- events ---------- */

    action: function (name, btn) {
      switch (name) {
        case 'start': this.start(); break;
        case 'play': this.togglePlay(); break;
        case 'prev': this.prevChapter(); break;
        case 'next': this.nextChapter(); break;
        case 'panel':
          this.setPanel(!this.panelOpen);
          if (this.panelOpen && this.layoutMode === 'overlay' && focusVisible(btn)) {
            var c = this.chapters[this.chapter] || this.chapters[0];
            if (c) c.btn.focus({ preventScroll: true });
          }
          break;
        case 'close-panel': this.setPanel(false); break;
        case 'captions': this.setCaptions(!this.cc); break;
        case 'mute': this.video.muted = !this.video.muted; break;
        case 'fullscreen': this.toggleFullscreen(); break;
      }
    },

    bind: function () {
      var self = this;
      var root = this.root;
      var v = this.video;
      var range = this.range;

      root.addEventListener('pointerdown', function (e) { self.pointerType = e.pointerType; });
      root.addEventListener('focusin', function (e) {
        if (self.bar.contains(e.target)) self.wake();
      });

      root.addEventListener('click', function (e) {
        var target = e.target;
        var chapter = target.closest('.svc__chapter');
        if (chapter) return self.chooseChapter(parseInt(chapter.getAttribute('data-index'), 10), focusVisible(chapter));
        var btn = target.closest('[data-action]');
        if (btn) {
          self.action(btn.getAttribute('data-action'), btn);
          self.wake();
          return;
        }
        if (target === v || target === self.stage) {
          // Mouse: click the film to play or pause. Touch: tap to show or hide the bar
          if (self.pointerType === 'mouse') self.togglePlay();
          else self.toggleControls();
        }
      });

      v.addEventListener('dblclick', function () { self.toggleFullscreen(); });

      root.addEventListener('pointermove', function (e) {
        if (e.pointerType === 'mouse') self.wake();
      });
      this.bar.addEventListener('pointerenter', function () { self.overBar = true; });
      this.bar.addEventListener('pointerleave', function () { self.overBar = false; self.scheduleHide(); });

      root.addEventListener('keydown', function (e) {
        if (e.altKey || e.ctrlKey || e.metaKey) return;
        var onButton = !!e.target.closest('button');
        var onRange = e.target === range;
        var handled = true;
        switch (e.key) {
          case ' ':
            if (onButton) return;
            self.togglePlay();
            break;
          case 'k': case 'K': self.togglePlay(); break;
          case 'ArrowLeft':
            if (e.shiftKey) self.prevChapter(); else self.seek(self.currentTime() - SKIP, self.wantPlay);
            break;
          case 'ArrowRight':
            if (e.shiftKey) self.nextChapter(); else self.seek(self.currentTime() + SKIP, self.wantPlay);
            break;
          case 'PageUp': if (!onRange) return; self.prevChapter(); break;
          case 'PageDown': if (!onRange) return; self.nextChapter(); break;
          case 'Home': if (!onRange) return; self.seek(0, self.wantPlay); break;
          case 'End': if (!onRange) return; self.seek(self.duration, false); break;
          case 'ArrowUp': case 'ArrowDown': if (!onRange) return; break;
          case 'f': case 'F': self.toggleFullscreen(); break;
          case 'c': case 'C': self.setCaptions(!self.cc); break;
          case 'm': case 'M': v.muted = !v.muted; break;
          case 'Escape':
            if (self.panelOpen && self.layoutMode === 'overlay' && !self.idle) {
              self.setPanel(false);
              if (self.barToggle) self.barToggle.focus();
            } else if (root.classList.contains('is-pseudo-fs')) {
              self.setPseudoFullscreen(false);
            } else {
              handled = false;
            }
            break;
          default: handled = false;
        }
        if (handled) {
          e.preventDefault();
          self.wake();
        }
      });

      // Scrubber. Pointers drive the track directly (iOS ignores taps on a range
      // track) and seek on release, so a drag never thrashes between parts. The
      // transparent range underneath serves the keyboard and assistive tech.
      var scrub = this.scrub;
      function pointAt(e) {
        var r = scrub.getBoundingClientRect();
        var x = Math.max(0, Math.min(e.clientX - r.left, r.width));
        return { t: x / r.width * self.duration, x: x };
      }
      function endDrag() {
        if (!self.dragging) return;
        self.dragging = false;
        root.classList.remove('is-dragging');
        self.hideTip();
        self.seek(self.dragT, self.wantPlay);
        self.scheduleHide();
      }
      scrub.addEventListener('pointerdown', function (e) {
        if (e.button > 0) return;
        e.preventDefault();
        var p = pointAt(e);
        self.dragging = true;
        self.dragT = p.t;
        root.classList.add('is-dragging');
        try { scrub.setPointerCapture(e.pointerId); } catch (err) { /* old browsers */ }
        self.paint(p.t);
        self.showTip(p.t, p.x);
      });
      scrub.addEventListener('pointermove', function (e) {
        var p = pointAt(e);
        if (self.dragging) {
          self.dragT = p.t;
          self.paint(p.t);
          self.showTip(p.t, p.x);
        } else if (e.pointerType !== 'touch') {
          self.showTip(p.t, p.x);
        }
      });
      scrub.addEventListener('pointerup', endDrag);
      scrub.addEventListener('pointercancel', endDrag);
      scrub.addEventListener('pointerleave', function () {
        if (!self.dragging) self.hideTip();
      });
      ['input', 'change'].forEach(function (name) {
        range.addEventListener(name, function () { self.seek(parseFloat(range.value), self.wantPlay); });
      });

      v.addEventListener('timeupdate', function () {
        self.settle();
        self.update();
      });
      v.addEventListener('loadedmetadata', function () {
        if (self.pendingLocal !== null && Math.abs(v.currentTime - self.pendingLocal) > 0.5) {
          v.currentTime = self.pendingLocal;
        }
        self.pendingLocal = null;
        // The last part tells us the film's exact length
        if (self.part === self.parts.length - 1 && isFinite(v.duration)) {
          var d = self.parts[self.part].start + v.duration;
          if (Math.abs(d - self.duration) > 0.25) {
            self.duration = d;
            self.layoutSegments();
            self.update();
          }
        }
      });
      ['seeked', 'loadeddata', 'canplay'].forEach(function (name) {
        v.addEventListener(name, function () {
          self.settle();
          if (name !== 'loadeddata') root.classList.remove('is-waiting');
          self.update();
        });
      });
      v.addEventListener('playing', function () {
        root.classList.add('has-started');
        root.classList.remove('is-waiting');
        self.settle();
        self.update();
      });
      v.addEventListener('waiting', function () { root.classList.add('is-waiting'); });
      v.addEventListener('play', function () {
        if (self.wantPlay) return;
        self.wantPlay = true;
        self.syncPlaying();
      });
      v.addEventListener('pause', function () {
        // Pauses from outside the bar (system media keys, a src swap mid-change) keep the UI honest
        if (!self.wantPlay || v.ended || self.pendingLocal !== null) return;
        self.wantPlay = false;
        self.syncPlaying();
      });
      v.addEventListener('ended', function () {
        if (self.part < self.parts.length - 1) {
          self.seek(self.parts[self.part + 1].start, true);
          return;
        }
        self.ended = true;
        self.wantPlay = false;
        self.syncPlaying();
      });
      v.addEventListener('volumechange', function () {
        root.classList.toggle('is-muted', v.muted);
        var btn = root.querySelector('[data-action="mute"]');
        if (btn) {
          btn.setAttribute('aria-pressed', v.muted ? 'true' : 'false');
          btn.setAttribute('aria-label', v.muted ? 'Unmute' : 'Mute');
        }
      });
      v.addEventListener('error', function () { root.classList.remove('is-waiting'); });

      document.addEventListener('fullscreenchange', function () { self.syncFullscreen(); });
      document.addEventListener('webkitfullscreenchange', function () { self.syncFullscreen(); });
      window.addEventListener('hashchange', function () { self.readHash(true); });
    }
  };

  // Reveal-on-scroll for the section header (theme.liquid arms .sunday-animate)
  var revealer = 'IntersectionObserver' in window && new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      revealer.unobserve(entry.target);
    });
  }, { threshold: 0.25 });

  function init(scope) {
    scope = scope || document;
    scope.querySelectorAll('[data-svc]').forEach(function (el) {
      if (!el.__svc) el.__svc = new Player(el);
    });
    if (revealer) {
      scope.querySelectorAll('.sunday-video-chapters .sunday-animate').forEach(function (el) { revealer.observe(el); });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  // theme editor: sections re-render in place
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
